const localizers = {
  'loading.msg': () => `Loading...`,
  'logon.message.msg': () => `Authentication is required. Enter a valid user ID and password.`,
  'logon.button.msg': () => `Login...`,
  'SASServer.logonError.msg': () => `Unable to log on to the server.`,
  'SASServer.genericError.msg': () => `The server cannot be reached.`,
}
export default localizers;
